module.exports = __webpack_public_path__ + "img/ruby.2ea0b7df.svg";